import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DOCUMENTS_SERVICE } from './service-url'


@Injectable({
  providedIn: 'root'
})
export class VeevaVaultService {
  constructor(private http: HttpClient) { }

  updatePriority(profiles: any[]): Observable<any> {
    return this.http.post(DOCUMENTS_SERVICE.updatePriority, profiles);
  }

  updateStatus(profileId: any[]): Observable<any> {
    return this.http.post(DOCUMENTS_SERVICE.updateStatus, profileId);
  }

  updateStatusActive(payload: {}): Observable<any> {
    return this.http.put(DOCUMENTS_SERVICE.updateStatusActive, payload);
  }  

}
